import { global } from ":shared/app";
import { getDate } from "../../SHARED/helpers/get-date";

const endpoints = {
  get: "/scoring/filtration/filterer-filtrations/",
  post: `scoring/filtration/create/`,
  put: (id: number) => `scoring/filtration/update/${String(id)}/`,
};

export type GET = {
  returns: {
    c_keys: string[]; // criteria keys, generated locally
    history: number[];
    criteria: {
      [k: string]: {
        name: string;
        min: number;
        max: number;
        tooltip: string;
        scale: { hint: string; grade: number }[];
      };
    };
    participants: {
      id: number;
      filtration_id: number | null;
      first_name: string;
      middle_name: string;
      last_name: string;
      email: string;
      mobile: string;
      gender: string;
      dob: string; // "2024-08-06 00:00:00";
      residence_country: string;
      city: string;
      nationality: string;
      major: string;
      tracks: string; // "sustainability, urban";
      track: {
        registered: string;
        options: string[];
        answer: string | null;
      };
      date: string;
      time: string;
      filtration_total: number;
      scores: Record<string, { answer: string; score: number }>;
      submission_status: "pending" | "done";
      status: "pending" | "done";
    }[];
  };
};
export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(
  //   import("../mocks/get").then(({ success }) => {
  //     const data = success as unknown as GET["returns"];
  //     data.c_keys = Object.keys(data.criteria);
  //     data.participants.forEach((t) => {
  //       // t.project_video = "https://www.youtube.com/watch?v=wrEK6mm4XpU&ab_channel=Abdodes";
  //       console.log("date is :: ", t.date);
  //       if (t.date != undefined && t.date.length > 0) {
  //         t.date = getDate(t.date);
  //       }
  //     });
  //     // const sample = r.success.teams[0];
  //     // console.log("asd :: ", sample.id);
  //     // for (let i = 0; i < 50; i++) {
  //     //   r.success.teams.push(sample);
  //     // }

  //     return data;
  //   }),
  // );
  return global.api
    .getAuth(endpoints.get)
    .then(async (res) => {
      const data = res.data as GET["returns"];
      data.c_keys = Object.keys(data.criteria);
      data.participants.forEach((t) => {
        // t.project_video = "https://www.youtube.com/watch?v=wrEK6mm4XpU&ab_channel=Abdodes";
        if (t.date != undefined && t.date.length > 0) {
          t.date = getDate(t.date);
        }
      });
      return Promise.resolve(data);
    })
    .catch((err) => {
      return Promise.reject(err);
    });
}

//
type AParticipant = GET["returns"]["participants"][number];
export type POST_PUT = {
  props: { participant: AParticipant; scores: Record<string, number | string> };
  // returns: AParticipant;
  returns: {
    filtration_id: number;
    total: number;
  };
};
export async function postOrPut(props: POST_PUT["props"]): Promise<POST_PUT["returns"]> {
  const participant = props.participant;
  const new_eval = participant.filtration_id == undefined;
  return (
    new_eval
      ? // ? global.api.postAuth(endpoints.post, props.scores)
        global.api.postAuth(endpoints.post, { ...props.scores, participant: participant.id })
      : global.api.putAuth(endpoints.put(participant.filtration_id), props.scores)
  ).then((res) => {
    const item = res.data;
    // res_team.eval_time = getDate(res_team.eval_time);
    return Promise.resolve(item);
  });
}
